// import RandomPattern from "./_elements/random-pattern";

import quicklink from 'quicklink/dist/quicklink.js';
import ImageCompare from './_elements/image-compare';
import MediaZoom from './_elements/media-zoom';
import ThemePicker from './_elements/theme-picker';

// document.addEventListener("DOMContentLoaded", function() {
// });

window.addEventListener('load', () => {
	quicklink.listen();
});
